// 투명 양면 재질은 three가 뒷면·앞면을 두 번에 나눠 그린다(side를 잠깐 BackSide·FrontSide로 바꿔서). compileAsync는 DoubleSide 한 번만
// 컴파일하므로, 처음 그릴 때 BackSide·FrontSide 파이프라인이 동기로 새로 만들어졌다(2026-11-03 PC 측정: 던전 입장·첫 사냥에 VFX 풀 17개).
// 가산 혼합은 그리는 순서와 결과가 무관하므로 한 번에 그려도 화면이 같다 → forceSinglePass로 바꿔 미리 컴파일이 그대로 쓰이게 한다.
import * as THREE from 'three/webgpu';

/** 가산 혼합 투명 양면 재질을 한 번에 그리게 한다. 바꾼 재질 수를 돌려준다(같은 재질은 한 번만 센다) */
export function singlePassAdditive(root: THREE.Object3D): number {
  let n = 0;
  const fix = (m: THREE.Material): void => {
    if (m.transparent && m.side === THREE.DoubleSide && m.blending === THREE.AdditiveBlending && !m.forceSinglePass) {
      m.forceSinglePass = true;
      m.needsUpdate = true;
      n++;
    }
  };
  root.traverse((o) => {
    const mat = (o as THREE.Mesh).material as THREE.Material | THREE.Material[] | undefined;
    if (!mat) return;
    if (Array.isArray(mat)) for (const m of mat) fix(m); else fix(mat);
  });
  return n;
}
